import store from '@/store'

const {body} = document
const map = {
    'xl': 1200,
    'lg': 992,
    'md': 768,
    'sm': 576
}
const WIDTH = map['lg'] // refer to Bootstrap's responsive design
export default {
    watch: {
        $route(route) {
            if (this.device === 'mobile') {
                store.dispatch('d2admin/menu/asideCollapseSet', true)
            }
        }
    },
    beforeMount() {
        window.addEventListener('resize', this.$_resizeHandler)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.$_resizeHandler)
    },
    mounted() {
        const isMobile = this.$_isMobile()
        if (isMobile) {
            store.dispatch('d2admin/app/toggleDevice', 'mobile')
            store.dispatch('d2admin/menu/asideCollapseSet', true)
        }
        store.dispatch('d2admin/app/toggleScreenSize', this.$_getScreenSizeLevel())
    },
    methods: {
        // use $_ for mixins properties
        // https://vuejs.org/v2/style-guide/index.html#Private-property-names-essential
        $_isMobile() {
            const rect = body.getBoundingClientRect()
            return rect.width - 1 < WIDTH
        },
        $_getScreenSizeLevel() {
            let size = null
            const rect = body.getBoundingClientRect()
            for (let key in map) {
                if (rect.width - 1 < map[key]) {
                    size = key
                }
            }
            return size
        },
        $_resizeHandler() {
            if (!document.hidden) {
                const isMobile = this.$_isMobile()
                store.dispatch('d2admin/app/toggleDevice', isMobile ? 'mobile' : 'desktop')
                if (isMobile) {
                    store.dispatch('d2admin/menu/asideCollapseSet', true)
                }
                store.dispatch('d2admin/app/toggleScreenSize', this.$_getScreenSizeLevel())
            }
        }
    }
}
